var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baidu-map',{staticStyle:{"height":"100%"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"scroll-wheel-zoom":true},on:{"ready":_vm.handler,"click":_vm.getClickInfo}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485de1d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/map/CommonMap.vue
// module id = null
// module chunks = 